import styled from 'astroturf/react'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useSelector } from 'react-redux'
import { useFlag } from '@calendly/feature-check-react'

import { CookieSettingsButton } from 'components/confirmation/layout'
import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import { ErrorComponent } from 'components/error_component'

import PackageDetails from '../new_confirmation/package_details'
import { eventTypeSelector } from '../../../../root-api'

import { PersonalizedHeader } from './header'
import { Details } from './details'
import { Layout } from './layout'
import { MarketingBanner } from './marketing_banner'
import _ExperimentContainer from "index-ExperimentContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/pages/personalized_confirmation/index.js?styleId=ExperimentContainer";
import _Left from "index-Left.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/pages/personalized_confirmation/index.js?styleId=Left";
import _Right from "index-Right.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/pages/personalized_confirmation/index.js?styleId=Right";


const ExperimentContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ExperimentContainer",
  styles: _ExperimentContainer,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isPhone: useDeviceType('isPhone')
  })
})

const Left = /*#__PURE__*/styled('div', null, {
  displayName: "Left",
  styles: _Left,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const Right = /*#__PURE__*/styled('div', null, {
  displayName: "Right",
  styles: _Right,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const PersonalizedConfirmation = () => {
  const isPhone = useDeviceType('isPhone')
  const { showDetails } = useConfirmationPageData()
  const eventType = useSelector(eventTypeSelector)
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  return (
    <Layout expanded hideBranding={bookingAppRedesign}>
      <ErrorComponent />
      <ExperimentContainer>
        {isPhone && <Right><PersonalizedHeader /></Right>}
        <Left>
          <Details />
        </Left>
        <Right>
          {!isPhone && <PersonalizedHeader />}
          <PackageDetails eventTypeUuid={eventType?.uuid} />
          {showDetails && <MarketingBanner />}
          <CookieSettingsButton />
        </Right>
      </ExperimentContainer>
    </Layout>
  )
}
